import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import { AppActions } from '../actions/action-types';
import { fetchTranslationsApi, fetchUserApi } from '../apis';
import { updateUser } from '../reducers/user-reducer';
import { updateTranslations } from '../reducers/translations-reducer';
import LOCALES from '../../constants/locales';

function* fetchTranslations({ payload }) {
  const { response } = yield call(fetchTranslationsApi, payload);
  const { status, data } = response;

  if (status) {
    yield put(updateTranslations(data));
  }
}

function* fetchUser() {
  const { response } = yield call(fetchUserApi, 'admin');
  const { status, data } = response;

  if (status) {
    yield put(updateUser(data));
  }
}

function* fetchAppMountedData() {
  yield call(fetchUser);
  yield fork(fetchTranslations, { payload: LOCALES.EN_US });
}

function* appMountedAction() {
  yield takeLatest(AppActions.APP_MOUNTED, fetchAppMountedData);
}

function* fetchTranslationsAction() {
  yield takeLatest(AppActions.FETCH_TRANSLATIONS, fetchTranslations);
}

export default function* root() {
  yield all([fork(appMountedAction), fork(fetchTranslationsAction)]);
}
